import { Card, Col, Row, Spin, Typography } from "antd";
import { motion } from "framer-motion";
import ReactApexChart from "react-apexcharts";
import { ApexOptions } from "apexcharts";
import { useEffect, useState } from "react";
import { periodAcitivityChartOptions, periodActivityPassageChartOptions } from "./helpers";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { useGetExamInstanceMonitor, useGetExamPeriodById } from "@hooks";
import { ExamPeriodMonitorTable } from "@components";

export const ExamPeriodMonitoringPage = () => {
 
  const { t } = useTranslation();
  
  const { id } = useParams();
  const { data: exam, isLoading } = useGetExamPeriodById(id ? id : "");

  const { data: monitorData, isLoading: monitorLoading } =
    useGetExamInstanceMonitor(id ? id : "");

  const [chartOptions, setChartOptions] = useState<ApexOptions>(periodAcitivityChartOptions(t, monitorData));
  const [chartPassageOptions, setChartPassageOptions] = useState<ApexOptions>(periodActivityPassageChartOptions(t, monitorData));

  useEffect(() => {
    if (monitorData) {
      setChartOptions(periodAcitivityChartOptions(t, monitorData))
      setChartPassageOptions(periodActivityPassageChartOptions(t, monitorData))
    }
  }, [monitorData]);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 1 }}
    >
      <Spin spinning={isLoading}>
        <div
          style={{ display: "flex", flexDirection: "row", marginBottom: 20 }}
        >
          <div
            style={{
              width: 3,
              backgroundColor: "#F1B80E",
              borderRadius: 100,
              marginRight: 12,
            }}
          />
          <Typography.Title level={3} style={{ margin: 0 }}>
            {t("pages.activity.name")}
          </Typography.Title>
        </div>
        <Row gutter={16}>
          <Col span={18}>
            <ExamPeriodMonitorTable exam={exam} monitorData={monitorData} isLoading={monitorLoading}/>
          </Col>
          <Col span={6}>
            <Card title={t("pages.activity.stats")}>
              <div style={{ display: "flex", justifyContent: "center" }}>
                <ReactApexChart
                  options={chartOptions}
                  series={chartOptions.series}
                  type="donut"
                  width={300}
                />
              </div>
              <div style={{ display: "flex", justifyContent: "center" }}>
                <ReactApexChart
                  options={chartPassageOptions}
                  series={chartPassageOptions.series}
                  type="donut"
                  width={300}
                />
              </div>
            </Card>
          </Col>
        </Row>
      </Spin>
    </motion.div>
  );
};
